module.exports = __webpack_public_path__ + "static/media/Fig-5-Grenade.9587873d.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/Fig-5-Grenade.png
// module id = 715
// module chunks = 0